import type { Composer } from "vue-i18n";

export const defaultError = (t: Composer["t"]) => t('errors.message-default')
